import React from 'react';
import { useThemeMode } from '../../ThemeContext';

function Toggle({ checked, onChange }) {
  return (
    <button
      onClick={() => onChange(!checked)}
      aria-pressed={checked}
      style={{
        width: 56,
        height: 30,
        borderRadius: 999,
        border: '1px solid rgba(0,0,0,0.12)',
        background: checked ? '#0FB5B3' : '#d9d9d9',
        position: 'relative',
        cursor: 'pointer',
        padding: 0,
      }}
    >
      <span
        style={{
          position: 'absolute',
          top: 3,
          left: checked ? 30 : 3,
          width: 24,
          height: 24,
          background: '#fff',
          borderRadius: '50%',
          transition: 'left 0.15s ease',
          boxShadow: '0 2px 5px rgba(0,0,0,0.15)'
        }}
      />
    </button>
  );
}

function Row({ label, control }) {
  const { mode } = useThemeMode();
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 4px' }}>
      <div style={{ color: mode === 'dark' ? '#FFFFFF' : '#2c3e50', fontWeight: 600 }}>{label}</div>
      {control}
    </div>
  );
}

function ThemePreferences() {
  const { mode, toggleTheme } = useThemeMode();
  return (
    <div>
      <Row label="Light" control={<Toggle checked={mode === 'light'} onChange={toggleTheme} />} />
      <Row label="Dark" control={<Toggle checked={mode === 'dark'} onChange={toggleTheme} />} />
    </div>
  );
}

export default ThemePreferences;


